export { default } from './SavedCoursesSkeleton';
